// Compile-time flag. CRA inlines REACT_APP_* from .env.production.
// Production default is false; marketing demo deploys set this to the string "true".
export const DEMO_MODE = process.env.REACT_APP_DEMO_MODE === 'true';
